import { ChakraProvider as RawProvider } from '@chakra-ui/provider'
import { ChakraProvider, extendTheme } from '@chakra-ui/react'
import { baseTheme } from '@micin-jp/curon-ui'
import React from 'react'
import { useClientSetting } from 'src/clientSetting/Provider'
import { clientTheme } from './clientTheme'
import { ThemeContext } from './Context'

const ClientThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const clientSetting = useClientSetting()
  const theme = clientTheme[clientSetting.id]

  return (
    <ThemeContext.Provider
      value={{
        theme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  )
}

export const ChakraWithClientThemeProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <ClientThemeProvider>
      <ThemeContext.Consumer>
        {value => <ChakraProvider theme={value.theme}>{children}</ChakraProvider>}
      </ThemeContext.Consumer>
    </ClientThemeProvider>
  )
}

const curonTheme = extendTheme(baseTheme)

// 段階的に @micin-jp/curon-ui 提供のコンポーネントを使うように切り替えていっている
// @micin-jp/curon-ui のコンポーネントを使う場合は、この Provider でラップして利用する
export const CuronUIThemeProvider = ({ children }: { children: React.ReactNode }) => {
  // NOTE: @chakra-ui/react から import した ChakraProvider を利用すると、トースト表示に問題が起こるケースがあり、 @chakra-ui/provider を利用している
  // 参考: https://github.com/chakra-ui/chakra-ui/issues/6328
  return <RawProvider theme={curonTheme}>{children}</RawProvider>
}
